export default __webpack_public_path__ + "images/icon-flag.png?5fe620cb36d3b183104031b28367b91b";